import { CREATE_TICKET_DATA, CREATE_TICKET_ERROR, CREATE_TICKET_HIDE_ERROR, CREATE_TICKET_START_LOADER, CREATE_TICKET_STOP_LOADER, } from "../interface/CreateTickets";
const initialState = {
    data: {},
    createTicketLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const CreateTicketReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_TICKET_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case CREATE_TICKET_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CREATE_TICKET_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case CREATE_TICKET_START_LOADER:
            return Object.assign(Object.assign({}, state), { createTicketLoader: true });
        case CREATE_TICKET_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { createTicketLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default CreateTicketReducer;
